export class Controller {

    /** @ngInject */
    constructor($state, Alert, IdpAuthenticatorsService) {
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
        this.Alert = Alert;
        this.$state = $state;
    }

    $onInit() {
    }

    addNewIdpAuthenticator() {
        return this.$state.go('company.idp-authenticators.add');
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/list/idp-authenticators-list.controller.js